import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-custom-dialog-modal',
  templateUrl: './custom-dialog-modal.component.html',
  styleUrls: ['./custom-dialog-modal.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CustomDialogModalComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  isNoBtnVisible = false;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.isNoBtnVisible = this.btnCancelText !== '' ? true : false;
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
